import { Card, CardBody, Image } from '@heroui/react';
import React from 'react';

/**
 * IsPuppyIndicator - Shows a visual indicator for test users or non-production environments
 *
 * This component displays a "Dog Fooder" badge to identify test users or development environments.
 * It helps developers and testers understand the current context they're working in.
 *
 * Features:
 * - Shows for test users (when isTestUser is true)
 * - Optionally shows for non-production environments (when showForEnvironment is true)
 * - Displays environment emoji and name
 * - Shows the iconic "cookitiano" dog image
 * - Sticky positioning to stay visible during scrolling
 * - Responsive design with HeroUI components
 */
export const IsPuppyIndicator: React.FC = () => {
  return (
    <div className="sticky top-0 z-50 flex justify-center py-2">
      <Card className="bg-warning-50 border-2 border-warning-200 shadow-lg">
        <CardBody className="flex flex-row items-center gap-3 px-4 py-3">
          {/* Dog Image */}
          <Image
            src="/icons/dogs/cookitiano.jpg"
            alt="Dog Fooder"
            className="w-12 h-12 rounded-full border-2 border-warning-300"
            classNames={{
              wrapper: 'flex-shrink-0',
            }}
          />

          {/* User/Environment Info */}
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="text-lg" role="img">
                🐶
              </span>
              <span className="text-sm font-semibold text-warning-800">
                Dog Fooder
              </span>
            </div>
            <span className="text-xs text-warning-700">Puppy User</span>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
